import { createRoot } from 'react-dom/client'
import { Provider } from 'jotai'
import './index.css'
import '@repo/fonts/fontInter.css'
import '@repo/fonts/fontPoppins.css'
import '@repo/fonts/fontVariables.css'
import App from './App'
import { appStore } from './core/store/jotai.store'
import { setupLoaderTrackingInterceptor } from './core/loader/interceptors/loaderTrackingInterceptor'

// Setup loader tracking interceptor BEFORE any API calls
setupLoaderTrackingInterceptor()

// Clear glic2027-related storage on every page refresh
const clearGlic2027Storage = () => {
    // List of glic2027-related localStorage keys to clear
    const localStorageKeys = ['glic2027_language', 'glic2027_customer', 'glic2027_cart', 'glic2027_session']

    // Clear specific localStorage keys
    localStorageKeys.forEach(key => {
        localStorage.removeItem(key)
    })

    // Also clear any keys that start with 'glic2027_'
    const keysToRemove: string[] = []
    for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i)
        if (key && key.startsWith('glic2027_')) {
            keysToRemove.push(key)
        }
    }
    keysToRemove.forEach(key => localStorage.removeItem(key))

    // Clear all sessionStorage (session-specific data)
    sessionStorage.clear()
}

// Execute on page load/refresh
clearGlic2027Storage()

createRoot(document.getElementById('root')!).render(
    <Provider store={appStore}>
        <App />
    </Provider>
)
